import { useState, useEffect } from 'react';
import '../styles/NewsCarousel.css';

const READ_MORE_URL = 'https://flare.network/news/from-activity-to-value-accrual-our-plan-for-flr';

const SLIDES = [
  {
    id: 'flr-plan',
    date: 'APR 8, 2026',
    headline: 'From activity to value accrual: Our plan for FLR',
    graphic: 'news-graphic-1.webp',
    brand: 'flare-icon.png',
    brandAlt: 'Flare',
  },
  {
    id: 'firelight',
    date: 'DEC 3, 2025',
    headline: 'Stake your FXRP on Firelight: Now live',
    graphic: 'news-graphic-2.webp',
    brand: 'firelight-logo.webp',
    brandAlt: 'Firelight',
  },
  {
    id: 'xaman',
    date: 'FEB 26, 2026',
    headline: 'One-Click DeFi Vault with Xaman, powered by Flare Smart Accounts & FAssets',
    graphic: 'news-graphic-3.svg',
    brand: 'xaman-logo.svg',
    brandAlt: 'Xaman',
  },
];

const ROTATE_MS = 6000;

function NewsCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, ROTATE_MS);

    return () => clearInterval(timer);
  }, []);

  const activeSlide = SLIDES[activeIndex];

  return (
    <section className="news">
      <div className="news__card" key={activeSlide.id}>
        <div className="news__graphic-wrap">
          <img
            src={`${process.env.PUBLIC_URL}/images/${activeSlide.graphic}`}
            alt=""
            className="news__graphic"
          />
        </div>

        <div className="news__content">
          <div className="news__meta">
            <span className="news__label">Flare Featured News</span>
            <span className="news__date">{activeSlide.date}</span>
          </div>

          <h3 className="news__headline">{activeSlide.headline}</h3>

          <img
            src={`${process.env.PUBLIC_URL}/images/${activeSlide.brand}`}
            alt={activeSlide.brandAlt}
            className="news__brand"
          />

          <div className="news__footer">
            <span className="news__tag">Flare Updates</span>
            <a href={READ_MORE_URL} className="news__readmore">
              Read more <span className="news__arrow">→</span>
            </a>
          </div>
        </div>
      </div>

      <div className="news__dots">
        {SLIDES.map((slide, i) => (
          <button
            key={slide.id}
            className={`news__dot ${i === activeIndex ? 'news__dot--active' : ''}`}
            aria-label={`Go to news item ${i + 1}`}
            onClick={() => setActiveIndex(i)}
          />
        ))}
      </div>
    </section>
  );
}

export default NewsCarousel;